import { Component, OnInit } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-report-ae-pc-popup',
  templateUrl: './report-ae-pc-popup.component.html',
  styleUrls: ['./report-ae-pc-popup.component.css']
})
export class ReportAePcPopupComponent implements OnInit {

  reporterType: string = "";
  selectedLink: string = "";
  isUS_Profile: boolean = false;
  isMNKLink: boolean = true;
  public onClose: Subject<boolean>;

  constructor(public options: ModalOptions,
    public _bsModalRef: BsModalRef) {
    this.onClose = new Subject();
  }

  ngOnInit(): void {
    let request = this.options.initialState as any;
    this.reporterType = request.reportType;
    this.isUS_Profile = request.isUSProfile;
  }

  navigateToLink(link: string, isMNK: boolean): void {
    this.selectedLink = link;
    this.isMNKLink = isMNK;
  }

  cancel(){
    this.selectedLink = "";
    this._bsModalRef.hide();
  }
}
